<template>
  <div id="app relative">
    <!-- <Navbar v-show="$route.path !== '/dashboard'" class="fixed top-0 left-0 right-0" /> -->
    <transition name="fade" mode="out-in">
      <keep-alive>
        <slot />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
// import Navbar from '@/components/navbar'
import generateShareCard from '@jlengstorf/get-share-image'

export default {
  name: 'App',
  components: {
    // Navbar
  },
  metaInfo () {
    const shareImage = generateShareCard({
      cloudName: 'xtellar',
      title: ' ',
      imagePublicID: 'PhanerooPrayer/phaneroo-prayer-requests-dark'
    })

    return {
      title: 'Phaneroo Prayer Requests',
      titleTemplate: '%s | Phaneroo',
      meta: [
        {
          name: 'author',
          content: 'Phaneroo'
        },
        {
          name: 'image',
          content: shareImage
        },
        {
          name: 'description',
          content: 'Golden Altar for Phaneroo Prayer Requests'
        },
        {
          name: 'twitter:site',
          content: '@phanerookampala'
        },
        {
          name: 'twitter:title',
          content: 'Phaneroo Prayer Requests'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:creator',
          content: '@phanerookampala'
        },
        {
          name: 'image',
          property: 'og:image',
          content: shareImage
        },
        {
          name: 'description',
          property: 'og:description',
          content: 'Golden Altar for Phaneroo Prayer Requests'
        }
      ]
    }
  }
}
</script>

<style lang="scss">

.main {
  margin-top: 52px;
}
</style>
